import { Button } from "@madhive/kit-ui";
import { ManageCampaignsRoute, Routes } from "lib/constants/routes";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Component that renders the Maverick Global Navigation Actions,
 * primarily used for including the "Exit Agent" button.
 * But can be extended in the future to include other global actions.
 */
function MaverickGlobalNavActions() {
  const navigate = useNavigate();
  const location = useLocation();

  function handleNavigate(link: string | undefined) {
    if (!link) {
      return;
    }
    navigate(link);
  }

  const exitLink = getExitLink(location.pathname);

  if (!exitLink) {
    return null;
  }

  return (
    <div className="maverick-global-nav-actions">
      <Button
        variant="ghost"
        className="maverick-theme"
        prefix="Exit"
        onClick={() => handleNavigate(exitLink)}
        data-testid="maverick-global-nav-actions-exit"
      >
        Exit Agent
      </Button>
    </div>
  );
}

function getExitLink(locationPath: string): string | undefined {
  if (
    locationPath.startsWith(
      `/ai${Routes.MANAGE_CAMPAIGNS}/${ManageCampaignsRoute.CREATE_CAMPAIGN}`
    )
  ) {
    return Routes.MANAGE_CAMPAIGNS;
  }
  return undefined;
}

export default MaverickGlobalNavActions;
